import React from 'react';
import './AgeVerificationModal.css';

function AgeVerificationModal({ onEnter, onExit }) {
  return (
    <div className="age-modal-overlay">
      <div className="age-modal-content">
        <h2 className="age-modal-title">Proceed to Telegram</h2>
        <p className="age-modal-text">
          This website contains age-restricted materials including nudity and explicit depictions of sexual activity. By entering, you affirm that you are at least 18 years of age or the age of majority in the jurisdiction you are accessing the website from and you consent to viewing sexually explicit content.
        </p>
        <div className="age-modal-buttons">
          <button 
            className="age-modal-button age-modal-button-enter" 
            onClick={onEnter}
          >
            I am 18 or older - Enter
          </button>
          <button 
            className="age-modal-button age-modal-button-exit" 
            onClick={onExit}
          >
            I am under 18 - Exit
          </button>
        </div>
      </div>
    </div>
  );
}

export default AgeVerificationModal;

